import { useEventBus, type EventBusKey } from '@vueuse/core'

type FolderEventBusEvent = 'create-folder'
type FolderEventBusPayload = {
  folderId: string
}

const key: EventBusKey<FolderEventBusEvent> = Symbol('folder-event-bus')

/**
 * This is a shared event bus for folder events. It is used to
 * communicate events between components that are far removed
 * in the component tree. e.g. after the user creates a folder,
 * they should be prompted to rename it.
 */
export const folderEventBus = useEventBus<FolderEventBusEvent, FolderEventBusPayload>(key)
